// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC } from 'react'

import { trackEvent } from '../../../../../../lib/analytics'

import { Container, ToggleButton } from './styles'

import type { KitToggle as KitToggleType } from '../../../../../../__generated__/graphql/catalog/graphql'

type Props = {
  kitHandle: string
  kitToggles?: ReadonlyArray<KitToggleType>
}

export const KitToggle: FC<Props> = ({ kitHandle, kitToggles }) => {
  const { query } = useRouter()
  const showToggle = kitToggles && kitToggles.length > 1

  if (!showToggle) return null

  const { handle: _handle, ...queryWithoutHandle } = query

  return (
    <Container>
      {kitToggles.map(toggle => (
        <ToggleButton
          key={toggle.id}
          as={Link}
          href={{
            pathname: `/kits/${toggle.kitHandle}`,
            query: queryWithoutHandle,
          }}
          isSelected={toggle.kitHandle === kitHandle}
          scroll={false}
          replace
          {...trackEvent({
            action: 'kit toggle clicked',
            category: 'kit details',
            label: toggle.kitHandle,
          })}
        >
          {toggle.name}
        </ToggleButton>
      ))}
    </Container>
  )
}
